import React from 'react';
import { Helmet } from 'react-helmet-async';

import { JOY_BRAND_NAME } from '@shared/utils/constants';

type LinkPreviewHeadProps = Readonly<{
  url: string;
  title: string;
  imageUrl: string;
  imageAlt?: string;
  description?: string;
}>;

/** Preview tags crawlers read from the server-rendered page. Tags with no value are left out. */
export const LinkPreviewHead: React.FC<LinkPreviewHeadProps> = ({ title, description, imageUrl, imageAlt, url }) => (
  <Helmet title={`${title} | ${JOY_BRAND_NAME}`}>
    <meta
      property="og:title"
      content={title}
    />
    <meta
      property="og:site_name"
      content={JOY_BRAND_NAME}
    />
    {description && (
      <meta
        property="og:description"
        content={description}
      />
    )}
    <meta
      property="og:url"
      content={url}
    />
    <meta
      property="og:image"
      content={imageUrl}
    />
    {imageAlt && (
      <meta
        property="og:image:alt"
        content={imageAlt}
      />
    )}
    <meta
      property="og:type"
      content="website"
    />
    <meta
      name="twitter:card"
      content="summary_large_image"
    />
    <meta
      name="twitter:title"
      content={title}
    />
    {description && (
      <meta
        name="twitter:description"
        content={description}
      />
    )}
    <meta
      name="twitter:image"
      content={imageUrl}
    />
    {imageAlt && (
      <meta
        name="twitter:image:alt"
        content={imageAlt}
      />
    )}
    <meta
      name="twitter:site"
      content="@JoytheApp"
    />
  </Helmet>
);
